import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/system';

type BtnGradientProps = {
  handleButtonClick: () => void;
  text: string;
  sx?: SxProps<Theme>;
  width?: string;
  disabled?: boolean;
};

const BtnGradient: React.FC<BtnGradientProps> = (props) => {
  return (
    <Button
      onClick={props.handleButtonClick}
      disabled={props.disabled}
      sx={{
        width: props.width ? props.width : '80px',
        height: '32px',
        lineHeight: '14px',
        fontSize: '12px',
        fontWeight: '700',
        color: 'primary.light',
        p: '6px 11px',
        background: 'linear-gradient(95.64deg, #00C3FF 0%, #0090F8 100%)',
        '&:hover': { opacity: 0.8 },
        ...props.sx
      }}
    >
      {props.text}
    </Button>
  );
};

export default BtnGradient;
